export enum TypeRelease {
    CR = 'Crédito',
    DB = 'Débito',
}
